<!-- Generic Mobile Number Field -->
<template>
  <div>

    <v-row>
      <v-col cols="12" md="12" sm="12"> 
        <div class="input-helper">
          <div class="element"> 
            <v-text-field
              v-model="cmpValue"
              maxlength="15"
              max="999999999999999"
              :tabindex="$attrs.tabindex"
              :label="cmpLabel"
              :placeholder="$attrs.placeholder"
              :readonly="$attrs.readonly"
              :disabled="$attrs.disabled"
              :outlined="$attrs.outlined"
              :dense="$attrs.dense"
              :error="$attrs.error"
              :rules="rules"
              :backgroundColor="$attrs.backgroundColor"
              :prefix="options.prefix"
              @paste="_paste"
              @keypress="_keyPress">

              <template slot="append" v-if="!$attrs.disabled">
                <v-btn x-small fab class="cleanBtn"
                  elevation="0"
                  tabindex="-1"
                  v-if="cmpValue != null && cmpValue != ''" 
                  @click="cmpValue = ''">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </div>
          <div class="flex-btn"> 
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

  import generic from '@/shared/utils/generic.js';

  export default {
    model: { prop: "value", event: "input" },
    props: {
      label: { type: String },
      rules: { type: Array },
      value: { type: String },
      options: { type: Object, default: function () { return { prefix: ""}; } },
    },
    emits: ["input"],
    data: () => ({
      length: 15,
      isRequired: undefined,
    }),
    created() {
      this.isRequired = generic.isRequired(this.rules);
    },     
    methods: {
      _keyPress($event) {
        // Only allow numbers and "+"
        const keyCode = $event.keyCode ? $event.keyCode : $event.which;
        const value = $event.target.value;
        if ((keyCode !== 43 && keyCode < 48) || keyCode > 57 || keyCode === 43 && value.length > 0) $event.preventDefault();
        if (this.targetLength()) $event.preventDefault();
      },
      _paste($event) {
        const pastedValue = $event.clipboardData.getData('text').replaceAll("+", "");
        if (!pastedValue.isNumeric()) $event.preventDefault();
      },

      targetLength() {
        if (!this.value) return false;
        return this.value.length >= this.length;
      },      
    },
    computed: {
      cmpValue: {
        get: function () { return this.value; },
        set: function (newValue) { this.$emit("input", newValue); },
      },
      cmpLabel: {
        get() { return this.label + (this.isRequired ? ' *' : '') },
      }      
    }
  }
  
</script>

<style scoped>

</style>
